import {
  blue,
  green,
  grey,
  orange,
  purple,
  red,
  teal,
} from '@mui/material/colors';
import { ItemState, ValidationLevel } from '@/api/graphql';

/** `EXPORT_COMPLETED` → `Export completed`. */
export const humaniseState = (state: string): string => {
  const spaced = state.replace(/_/g, ' ').toLowerCase();
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
};

/**
 * State colours follow CVDS's scheme so the two tools read the same way: blue for newly arrived,
 * purple for locally modified, green for a completed export, red for a failure, orange for rejected.
 */
export const getStateColor = (state: ItemState): string => {
  switch (state) {
    case ItemState.New:
      return blue[400];
    case ItemState.Modified:
      return purple[300];
    case ItemState.ExportRequested:
      return teal[300];
    case ItemState.ExportCompleted:
      return green[400];
    case ItemState.ExportFailed:
      return red[400];
    case ItemState.Rejected:
      return orange[500];
    default:
      return grey[500];
  }
};

export const getValidationColor = (level?: ValidationLevel | null): string =>
  level === ValidationLevel.Error
    ? red[400]
    : level === ValidationLevel.Warning
    ? orange[400]
    : green[400];

export const formatBytes = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
};

export const formatDateTime = (iso?: string | null): string =>
  iso ? new Date(iso).toLocaleString() : '—';
